<template>
  <div class="expand-button">
    <button>{{ __('website.tariffs.more') }}</button>
    <ChevronIcon class="chevron" />
  </div>
</template>

<script>
import ChevronIcon from '@/components/icons/ChevronIcon';

export default {
  name: 'ExpandButton',

  components: {
    ChevronIcon,
  },
};
</script>

<style lang="sass" scoped>
.expand-button
  border-radius: 4px
  display: flex
  overflow: hidden
  position: relative
  button
    border: 0
    color: #fff
    font-size: 18px
    line-height: 32px
    font-weight: 500
    padding: 8px 56px 8px 24px
    background-color: rgba(255, 255, 255, .2)
    transition: background-color .25s
    &:hover
        background-color: rgba(255, 255, 255, .35)
  .chevron
    position: absolute
    pointer-events: none
    right: 28px
    top: 50%
    margin: -5px 0 0
</style>